import { gql } from '@apollo/client'

export const TASKS_BY_USER_QUERY = gql`
  query tasksByUser($sortBy: TasksByUserSort, $filter: TasksByUserFilter, $page: Int, $limit: Int) {
    tasksByUser(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        dueDate
        done
        completedAt
        caseIdentifier
        taskCategory {
          id
          name
          color
          textColor
        }
        processingId
        processing {
          caseId
          m2Case {
            policyholder {
              policyNumber
              lastname
              company
            }
            claimNumber
          }
        }
        __typename
      }
      metadata {
        totalCount
        currentPage
      }
    }
  }
`
